<template>
    <div class="info-view">
        <div class="info-view-line">
            <span class="info-view-title">请选择云机版本：</span>
            <el-select v-model="updateCardType" size="mini" placeholder="请选择" width="100px;" @change="changeEngineType(updateCardType)">
                <el-option
                        v-for="item in engineOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="info-view-line" v-if="updateCardType">
            <span class="info-view-title">引擎版本：</span>
            <span class="info-view-title">{{currentEngineVersion.versionCode}}</span>
        </div>
        <div class="info-view-line" v-if="updateCardType" style="margin-top: 10px;">
            <el-table ref="multipleTable" :data="updateRecordList" max-height="500px"
                      :header-cell-style="{backgroundColor: '#efefef'}" size="mini"
                      tooltip-effect="dark" style="width: 99%" >
                <el-table-column type="index"></el-table-column>
                <el-table-column prop="updateTime" label="升级时间" min-width="70px"></el-table-column>
                <el-table-column prop="versionName" label="升级版本" min-width="70px"></el-table-column>
                <el-table-column prop="fileName" label="升级文件" min-width="120px"></el-table-column>
                <el-table-column label="升级详情" min-width="120px">
                    <template slot-scope="scope">
                        当前已升级<span style="color: blue">{{scope.row.upgradeNum}}</span>路，
                        未升级<span style="color: red">{{scope.row.notUpgradeNum}}</span>路
                    </template>
                </el-table-column>
                <el-table-column min-width="60px" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="mini" style="margin-left: 10px;display: inline"
                                   @click="engineUpdateRecordDetailPop(scope.row)">查看详情
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <Drawer title="升级记录详情" :visible.sync="engineUpdateRecordDetailPopShow" :opt="false">
            <div v-if="engineUpdateRecordDetailPopShow">
                <el-form ref="form" size="mini" label-width="130px" label-position="left"
                         style="display: flex;flex-direction: column;height: 100%">
                    <el-form-item label="升级时间：" style="margin-bottom: 8px!important;" label-width="90px">
                        {{record.updateTime | formatDateTime}}
                    </el-form-item>
                    <el-form-item label="升级版本：" style="margin-bottom: 8px!important;" label-width="90px">
                        {{record.versionName}}
                    </el-form-item>
                    <el-form-item label="升级文件：" style="margin-bottom: 8px!important;" label-width="90px">
                        {{record.fileName}}
                    </el-form-item>
                    <el-form-item label="升级详情：" style="margin-bottom: 8px!important;" label-width="90px">
                        当前已升级{{record.upgradeNum}}路，
                        未升级<span style="color: red">{{record.notUpgradeNum}}</span>路。
                    </el-form-item>
                    <div style="width: 100%;border-bottom: 1px solid #ddd;margin-top: 10px"></div>
                    <div style="font-size: 16px;margin-bottom: 5px;margin-top: 10px">未升级设备</div>
                    <div style="display: flex;justify-content: stretch;font-size: 14px;color: #606266">
                        <div style="width: 20%">设备池ID</div>
                        <div style="width: 30%">设备IP</div>
                        <div style="width: 25%">设备版本</div>
                        <div style="width: 25%">所属分组</div>
                    </div>
                    <div style="display: flex;justify-content: stretch;font-size: 14px;padding: 2px 0"
                         v-for="detail in detailNotUpdateList">
                        <div style="width: 20%">{{detail.caseNo}}</div>
                        <div style="width: 30%">{{detail.deviceIp}}</div>
                        <div style="width: 25%">{{detail.versionCode}}</div>
                        <div style="width: 25%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis">
                            {{detail.groupName}}
                        </div>
                    </div>
                    <el-button type="text" size="mini" style="text-align: left;margin-top: 5px"
                               @click="completeShow = !completeShow">{{completeShow ? '&#9650点击收起已升级设备列表' :
                        '&#9660点击查看已升级设备列表'}}
                    </el-button>
                    <transition name="el-zoom-in-top">
                        <div v-show="completeShow">
                            <div style="font-size: 16px;margin-bottom: 5px;margin-top: 10px">已升级设备</div>
                            <div style="display: flex;justify-content: stretch;font-size: 14px;color: #606266">
                                <div style="width: 20%">设备池ID</div>
                                <div style="width: 30%">设备IP</div>
                                <div style="width: 25%">设备版本</div>
                                <div style="width: 25%">所属分组</div>
                            </div>
                            <div style="display: flex;justify-content: stretch;font-size: 14px;padding: 2px 0"
                                 v-for="detail in detailUpdateList">
                                <div style="width: 20%">{{detail.caseNo}}</div>
                                <div style="width: 30%">{{detail.deviceIp}}</div>
                                <div style="width: 25%">{{detail.versionCode}}</div>
                                <div style="width: 25%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis">
                                    {{detail.groupName}}
                                </div>
                            </div>
                        </div>
                    </transition>
                </el-form>
            </div>
        </Drawer>
    </div>
</template>

<script>
    import Drawer from '@/components/Drawer'
    export default {
        name: "CardUpdateRecord",
        components: {
            Drawer
        },
        data() {
            return {
                updateCardType: "",
                currentEngineVersion:"",
                engineList: [],
                bmEngineList: [],
                multipleSelection: [],
                engineUpdateRecordPopShow: false,
                updateRecordList: [],
                updateRecordDetail: [],
                engineUpdateRecordDetailPopShow: false,
                record: null,
                completeShow: false
            }
        },
        filters: {},
        computed: {
            engineOptions() {
                let list = []
                console.log("engineList is " + JSON.stringify(this.engineList))
                this.engineList.forEach(v => {
                    list.push({
                        label: v.engineTypeName,
                        value: v.engineType
                    })
                })
                // console.log("dddsdfadf")
                return list
            },
            bmEngineOptions() {
                let list = []
                this.bmEngineList.forEach(v => {
                    list.push({
                        label: v.content,
                        value: v.code
                    })
                })
                // console.log("dddsdfadf")
                return list
            },
            hasSelect() {
                return this.multipleSelection.length > 0;
            },
            detailUpdateList() {
                return this.updateRecordDetail.filter(d => {
                    return d.isUpgrade > 0
                })
            },
            detailNotUpdateList() {
                return this.updateRecordDetail.filter(d => {
                    return d.isUpgrade === 0
                })
            },
        },
        methods: {
            changeEngineType(updateCardType) {
                console.log("updateCardType " + updateCardType)
                this.getEngineUpdateRecord(updateCardType)
                for (let engine of this.engineList) {
                    console.log("engine is " + JSON.stringify(engine))
                    if (engine.engineType === updateCardType) {
                        this.currentEngineVersion = engine
                        break
                    }
                }
                console.log("currentEngineVersion " + JSON.stringify(this.currentEngineVersion))
            },
            getEngineUpdateRecord(engineType) {
                this.$post(this.$uri.system.updateRecord, {engineType: engineType}).then(res => {
                    if (res.success) {
                        this.updateRecordList = res.list
                        console.log("updateRecordList " + JSON.stringify(this.updateRecordList))
                    }
                })
            },
            engineUpdateRecordDetailPop(record) {
                this.$post(this.$uri.system.updateRecordDetail, {engineUpgradeId: record.id}).then(res => {
                    if (res.success) {
                        this.updateRecordDetail = res.list
                        this.record = record
                        this.completeShow = false
                        this.engineUpdateRecordDetailPopShow = true
                    }
                })
            },
            getEngineList() {//当前系统内的引擎版本列表
                this.$post(this.$uri.system.engineList, {}).then(res => {
                    console.log("engineList is " + JSON.stringify(res))
                    this.engineList = res.data
                })
            },
            getBmEngineList() {//引擎编码表
                this.$post(this.$uri.system.engineCodeList, {}).then(res => {
                    // console.log("res is " + JSON.stringify(res))
                    this.bmEngineList = res.list
                    // console.log("bmEngineList is " + JSON.stringify(this.bmEngineList))
                })
            },
            checkRow(r, c, e) {
                this.$refs.multipleTable.toggleRowSelection(r)
            },
            handleSelectionChange(val) {
                this.multipleSelection = val
                // console.log(this.multipleSelection)
            },
        },
        mounted() {
            this.getEngineList()
            this.getBmEngineList()
            this.getEngineUpdateRecord()
        }
    };
</script>

<style lang="less" scoped>
    .info-view {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        padding: 10px;
        /*border-bottom: 1px solid #E1E6EB;*/
        .info-view-line {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-bottom: 10px;
        }
        .info-view-title {
            text-align: left;
            font-size: 14px;
            /*font-weight: 600;*/
            /*padding: 5px 0;*/
        }
        .info-view-main {
            padding: 10px 10px 10px 120px;
            font-size: 12px;
            display: flex;
            flex-direction: column;
            align-items: left;
            justify-content: flex-start;
            .info-view-item {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                padding: 2px 0;
                height: 30px;
            }
            .info-view-item-btn {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: flex-start;
                padding: 5px 0;
            }
        }
    }

</style>